import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { CounterSigner, QuoteContact } from 'Cube/domain/cube.domain.types'

type UseSigners = () => {
  allSigners: Array<QuoteContact | CounterSigner>
  pendingSigners: Array<QuoteContact | CounterSigner>
  completedSigners: Array<QuoteContact | CounterSigner>
}

export const useSigners: UseSigners = () => {
  const ctx = useCubeContext()

  const externalSigners = ctx.queries.rawData.data.quote.contacts
  const counterSigners = ctx.queries.rawData.data.quote.counterSigners

  const allSigners = [...externalSigners, ...counterSigners]
  const pendingSigners = allSigners.filter(signer => !signer.signedAt)
  const completedSigners = allSigners.filter(signer => !!signer.signedAt)

  return { allSigners, pendingSigners, completedSigners }
}
